<template>
  <div>
    <noData />
  </div>
</template>

<script>
export default {
  name: 'NoFunction'
}
</script>
